module.exports = __webpack_public_path__ + "static/media/My-clients.1f4de8b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/HamburgerIcons/My-clients.svg
// module id = 572
// module chunks = 1